import { Pipe, PipeTransform } from '@angular/core';

const FILE_SIZES = ['B', 'KB', 'MB', 'GB', 'TB', 'PB'];

@Pipe({
  name: 'fileSize',
})
export class FileSizePipe implements PipeTransform {
  transform(value: number | string, decimals = 2): string {
    let size = Number(value);

    if (size === 0) {
      return '0 B';
    }

    let sizeIndex = 0;
    const dm = decimals <= 0 ? 0 : decimals;

    while (size >= 1024 && sizeIndex < FILE_SIZES.length - 1) {
      sizeIndex++;
      size /= 1024;
    }

    return `${size.toFixed(dm)} ${FILE_SIZES[sizeIndex]}`;
  }
}
